export const clearAuthData = () => {
  localStorage.clear();
};
